import { PollSlideTypes, ToBeDone } from '../db/types';
import { createRoute, RouteParams } from './helpers';

const home = createRoute({
  path: '/',
});

const auth = createRoute({
  path: 'login',
  dependsOn: home,
});

const DO_NOT_USE_ACADLY_SIGN_UP = createRoute({
  path: 'signup',
  dependsOn: home,
});

const course = createRoute({
  path: ':universitySlug/courses/:courseId',
  acadlyWebPath: ':universitySlug/courses/:courseId/timeline',
  dependsOn: home,
});

const cls = createRoute({
  path: 'classes/:classId',
  acadlyWebPath: 'classes/:classId',
  dependsOn: course,
});

const poll = createRoute({
  path: `polls/:pollId/:slideType(${PollSlideTypes.QUICK_POLL}|${PollSlideTypes.BAR_GRAPH}|${PollSlideTypes.PIE_CHART}|${PollSlideTypes.WORD_CLOUD})`,
  acadlyWebPath: 'activities/polls/:pollId',
  dependsOn: cls,
});

export type PollParams = RouteParams<typeof poll.path>;

const newPoll = createRoute({
  path: `polls/new/:toBeDone(${ToBeDone.IN_CLASS}|${ToBeDone.PRE_CLASS})/:slideType(${PollSlideTypes.QUICK_POLL}|${PollSlideTypes.BAR_GRAPH}|${PollSlideTypes.PIE_CHART}|${PollSlideTypes.WORD_CLOUD})`,
  acadlyWebPath: `activities/polls/new/:toBeDone(${ToBeDone.IN_CLASS}|${ToBeDone.PRE_CLASS})`,
  dependsOn: cls,
});

export type NewPollParams = RouteParams<typeof newPoll.path>;

const DO_NOT_USE_ACADLY_ATTENDANCE = createRoute({
  path: 'attendance',
  dependsOn: cls,
});

const attendance = createRoute({
  path: 'attendance',
  dependsOn: home,
});

const timer = createRoute({
  path: 'timer',
  dependsOn: home,
});

const restrictedPage = createRoute({
  path: 'restricted',
  dependsOn: home,
});

const routes = {
  auth,
  DO_NOT_USE_ACADLY_SIGN_UP,
  course,
  home,
  poll,
  newPoll,
  attendance,
  DO_NOT_USE_ACADLY_ATTENDANCE,
  timer,
  restrictedPage,
};

export default routes;
